import * as React from "react";

export function useSetState(initialState) {
  return React.useReducer(
    (prevState, nextState) => ({
      ...prevState,
      ...nextState,
    }),
    initialState
  );
}
